export class TaskStepStateViewModel {

  constructor(readonly stepNumber: number,
              readonly stepCount: number,
              readonly readonly: boolean
  ) {
  }

  get hasPrevious(): boolean {
    return this.stepNumber > 1;
  }

  get hasNext(): boolean {
    return this.stepNumber < this.stepCount;
  }
}
